import { render, staticRenderFns } from "./orderAppealAdd.vue?vue&type=template&id=7bc2bbbd"
import script from "./orderAppealAdd.vue?vue&type=script&lang=js"
export * from "./orderAppealAdd.vue?vue&type=script&lang=js"
import style0 from "./orderAppealAdd.vue?vue&type=style&index=0&id=7bc2bbbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports